import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  justify-content: ${props => props.align || 'center'};
  gap: 10px;
  flex-wrap: wrap;
`;

const ShareBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: ${props => props.btnStyle === 'icon' ? '40px' : 'auto'};
  height: 40px;
  padding: ${props => props.btnStyle === 'icon' ? '0' : '0 16px'};
  border-radius: ${props => props.round ? '50px' : '8px'};
  background: ${props => props.bg || 'var(--glass-2)'};
  color: #fff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 1px solid rgba(255,255,255,0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px ${props => props.shadow || 'rgba(0,0,0,0.2)'};
    filter: brightness(1.1);
  }

  svg { width: 16px; height: 16px; }
`;

const SocialShareWidget = ({ node }) => {
  const align = node.style?.desktop?.align || 'center';
  const btnStyle = node.style?.desktop?.btnStyle || 'text'; // 'icon' or 'text'
  const isRound = node.style?.desktop?.isRound !== false;

  return (
    <Wrapper align={align}>
      <ShareBtn href="#" bg="#1DA1F2" shadow="rgba(29, 161, 242, 0.4)" btnStyle={btnStyle} round={isRound} className="tef-bubbles">
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
        {btnStyle !== 'icon' && 'Posten'}
      </ShareBtn>

      <ShareBtn href="#" bg="#0a66c2" shadow="rgba(10, 102, 194, 0.4)" btnStyle={btnStyle} round={isRound} className="tef-bubbles">
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
        {btnStyle !== 'icon' && 'Teilen'}
      </ShareBtn>

      <ShareBtn href="#" bg="#25D366" shadow="rgba(37, 211, 102, 0.4)" btnStyle={btnStyle} round={isRound} className="tef-bubbles">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>
        {btnStyle !== 'icon' && 'WhatsApp'}
      </ShareBtn>
    </Wrapper>
  );
};

registry.register('social_share', {
  label: 'Teilen Buttons',
  icon: '🔗',
  category: 'social',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', btnStyle: 'text', isRound: false } },
  render: SocialShareWidget,
  inspectorControls: [
    {
      tab: 'style',
      groups: [
        {
          title: 'Button Styling',
          fields: [
            { name: 'style.desktop.btnStyle', label: 'Stil', type: 'select', options: [{label:'Text + Icon', value:'text'}, {label:'Nur Icon', value:'icon'}] },
            { name: 'style.desktop.isRound', label: 'Runde Ecken (Pill)', type: 'select', options: [{label:'Ja', value:true}, {label:'Nein', value:false}] },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'flex-start'}, {label:'Zentriert', value:'center'}, {label:'Rechts', value:'flex-end'}] }
          ]
        }
      ]
    }
  ]
});
